module.exports = __webpack_public_path__ + "img/nedir-01.cb7da6a6.svg";